import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, PageHeader, Row, Col, Card } from 'antd'

import SynonymList from './SynonymList'
import Terms from './Terms'

@inject((store: any) => {
    const { synonymsStore } = store
    return { synonymsStore }
})
@observer
class Synonyms extends Component<any, any> {
    render() {
        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="מילון מושגים"
                    subTitle="הגדרות מושגים ומילים נרדפות למנוע החיפוש במערכת"
                />
                <Row gutter={10} style={{ padding: '0 2rem' }}>
                    <Col xs={14}>
                        <Card type="inner" title={<strong style={{ fontSize: '1.1rem' }}>קבוצות מושגים</strong>}>
                            <SynonymList />
                        </Card>
                    </Col>
                    <Col xs={10}>
                        <Card type="inner" title={<strong style={{ fontSize: '1.1rem' }}>מושגים במערכת</strong>}>
                            <Terms />
                        </Card>
                    </Col>
                </Row>
            </Layout>
        )
    }
}

export default withRouter(Synonyms)
